import { render, staticRenderFns } from "./CourseSummaryModal.vue?vue&type=template&id=d4f54cec&"
import script from "./CourseSummaryModal.vue?vue&type=script&lang=js&"
export * from "./CourseSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports